import { FileChannel } from 'src/store/files/types';

import { ApiMethods, ApiTags, appAPI } from '.';

export interface GetCompanyFileChannelsParams {
  companyId: string;
}

export interface GetCompanyFileChannelsResponse {
  fileChannels: FileChannel[];
}

export const fileChannelsApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getCompanyFileChannels: build.query<
      GetCompanyFileChannelsResponse,
      GetCompanyFileChannelsParams
    >({
      query: ({ companyId }) => ({
        path: `/entities/FILE_CHANNEL`,
        method: ApiMethods.get,
        options: {
          queryStringParameters: {
            companyId,
          },
        },
      }),
      providesTags: [ApiTags.fileChannels],
    }),
  }),
});

export const { useGetCompanyFileChannelsQuery } = fileChannelsApi;
